import { gql } from '@apollo/client';

export const AI_AGENTS_LIST_FOR_SELECT_QUERY = gql`
  query AIAgentsListForSelect(
    $companyId: Int!
    $after: String
    $first: Int
    $orderBy: AIAgentOrderByInput
  ) {
    aiAgents {
      listAIAgents(
        companyId: $companyId
        after: $after
        first: $first
        orderBy: $orderBy
      ) @connection(key: "infinite-scroll") {
        edges {
          cursor
          node {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
